export default "__VITE_ASSET__CCWNGbEg__"